<template>
    <div class="control_wrap">
        <el-form
            :model="searchForm"
            class="leader-style-form"
            style="padding: 0 40px;"
            label-width="80"
            :inline="true"
        >
            <el-form-item label="点位名称">
                <el-input
                    v-model="searchForm.point_name"
                    maxlength="50"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button @click="getControlPointList">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="table-wrap">
            <el-scrollbar style="height: 90%;">
                <el-table :data="tableList" border class="leader-style-table">
                    <el-table-column label="序号" align="center">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (pageNum - 1) * pageSize + scope.$index + 1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="采集点名称"
                        align="center"
                        property="point_name"
                    ></el-table-column>
                    <el-table-column
                        label="sn"
                        align="center"
                        property="sn"
                    ></el-table-column>
                    <el-table-column
                        label="状态"
                        align="center"
                        property="last_on_off_status_name"
                    ></el-table-column>
                    <el-table-column label="操作" align="center" width="210">
                        <template slot-scope="scope">
                            <!-- <el-button
                                type="text"
                                @click="controlSwitch(scope.row)"
                                v-if="
                                    scope.row.switch_type == 10 &&
                                        scope.row.last_status == 0
                                "
                            ></el-button> -->
                            <el-button
                                type="text"
                                @click="controlSwitch(scope.row)"
                                v-if="scope.row.last_on_off_status != null"
                                >{{
                                    scope.row.last_on_off_status == 0
                                        ? "闭合"
                                        : "断开"
                                }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>

            <el-pagination
                class="leader-style-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api";
export default {
    data() {
        return {
            searchForm: {
                point_name: ""
            },
            tableList: [],
            pageNum: 1, //页码
            pageSize: 10, //每页条数
            currentPage: 1, //当前页码
            totalNum: 0, //总条数
            timer: null
        };
    },
    created() {
        this.getControlPointList();
        this.timer = setInterval(() => {
            this.getControlPointList();
        }, 3000);
    },
    methods: {
        getControlPointList() {
            api.getControlPointList({
                point_name: this.searchForm.point_name,
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.tableList = res.bus_json.items;
                    this.totalNum = res.bus_json.totalNum;
                }
            });
        },
        controlSwitch(row) {
            const point_control_id = row.point_control_id;
            let params = {};
            if (row.switch_type == "10") {
                // 只能断开的开关
                params = {
                    redis_key: row.redis_key,
                    point_control_id,
                    value_on_off: row.last_on_off_status == "0" ? "1" : "0"
                };
            }
            this.$confirm("确认操作?", "提示", {
                confirmButtonText: "保存",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.setProperty(params).then(res => {
                        if (res && res.error_code == 0) {
                            // 每隔一秒调用一次
                            const loading = this.$loading({
                                lock: true,
                                text: "努力加载中...",
                                spinner: "el-icon-loading",
                                background: "rgba(0, 0, 0, 0.7)"
                            });
                            const interval = setInterval(() => {
                                api.setPropertyResult({
                                    redis_key: row.redis_key
                                }).then(res => {
                                    if (res && res.error_code == 0) {
                                        // 返回结果，终止循环
                                        clearInterval(interval);
                                        loading.close();
                                        this.getControlPointList();
                                    } else if (res && res.error_code == 3) {
                                        // 等待中
                                    } else if (res && res.error_code == 1) {
                                        // 失败
                                        // this.$message({
                                        //     type: "error",
                                        //     message: res.error_msg
                                        // });
                                        // 返回结果，终止循环
                                        clearInterval(interval);
                                        loading.close();
                                    }
                                });
                            }, 1000);
                            // 循环调用60次
                            setTimeout(() => {
                                clearInterval(interval);
                                loading.close();
                            }, 1000 * 60);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消操作"
                    });
                });
        },
        /**
         * 列表条数改变回调
         */
        handleSizeChange(e) {
            this.pageNum = 1;
            this.pageSize = e;
            this.getControlPointList();
        },
        /**
         * 企业列表页码改变回调
         */
        handleCurrentChange(e) {
            this.pageNum = e;
            this.getControlPointList();
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.control_wrap {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
}
</style>
